import { Component } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import get from 'transmute/get';
import { Flex } from 'foundations-components/components/Flex';
import { Hoverlay } from 'foundations-components/transitional/components/Hoverlay';
import ChatFilterOptions from 'conversations-internal-schema/constants/ChatFilterOptions';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getInboxName } from 'conversations-internal-schema/inbox/operators/getInboxName';
import { gatherPerformanceMetrics } from 'conversations-thread-view/performance-metrics/operators/gatherPerformanceMetrics';
import { recordDuration } from '../../performance-metrics/gatherPerformanceMetrics';
import { ASSIGNMENT_REMOVAL, FILTER_CHANGE_REMOVAL, FILTER_MISALIGNMENT, THREAD_STATUS_REMOVAL, ASSOCIATED_TICKET_REMOVAL, HARD_DELETION_REMOVAL, UNKNOWN_REMOVAL, INBOX_CHANGE_REMOVAL } from '../../thread-list-member-overlay/constants/overlayTypes';
import { getType, getStatus } from '../../thread-list-member-overlay/operators/threadListMemberOverlayGetters';
import AssignmentRemovalOverlayMessage from './AssignmentRemovalOverlayMessage';
import { MARK_AS_SPAM_MARKER, MARK_THREAD_AS_CLOSED_MARKER, MOVE_TO_TRASH_MARKER, UNMARK_AS_SPAM_MARKER } from 'conversations-thread-view/performance-metrics/constants/performanceConstants';
import MoveAndAssignErrorOverlayMessage from './MoveAndAssignErrorOverlayMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getDynamicNamespace } from 'conversations-infrastructure/i18n/getDynamicNamespace';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const inboxChangeRemovalErrors = ['inboxChangeAssignmentAndCommentError', 'inboxChangeRemovalAssignmentError', 'inboxChangeRemovalCommentError'];
class ThreadListMemberOverlay extends Component {
  renderOverlayMessage({
    focusedThreadListMemberHasTickets,
    isAssociatedTicketOpen,
    moveAndAssignError,
    overlay
  }) {
    let message;
    let options;
    const overlayType = getType(overlay);
    switch (overlayType) {
      case FILTER_CHANGE_REMOVAL:
        {
          const filtered = get('filtered', overlay);
          if (filtered) {
            recordDuration(MARK_AS_SPAM_MARKER);
            message = 'conversations-inbox-ui.thread-list-member-overlay.filterChangeRemoval.filtered';
          } else {
            recordDuration(UNMARK_AS_SPAM_MARKER);
            message = 'conversations-inbox-ui.thread-list-member-overlay.filterChangeRemoval.unfiltered';
          }
          break;
        }
      case FILTER_MISALIGNMENT:
        {
          message = 'conversations-inbox-ui.thread-list-member-overlay.filterMisalignment';
          break;
        }
      case ASSOCIATED_TICKET_REMOVAL:
        {
          message = 'conversations-inbox-ui.thread-list-member-overlay.ticketAssociationRemoval';
          break;
        }
      case HARD_DELETION_REMOVAL:
        {
          message = 'conversations-inbox-ui.thread-list-member-overlay.hardDeletionRemoval';
          break;
        }
      case INBOX_CHANGE_REMOVAL:
        {
          const inboxId = get('inboxId', overlay);
          const inbox = this.props.inboxes.find(inboxData => get('id', inboxData) === inboxId);
          options = {
            inboxName: moveAndAssignError ? moveAndAssignError.variables.destinationInboxName : getInboxName(inbox)
          };
          const hasAssignmentError = moveAndAssignError && (moveAndAssignError.assignThreadError || moveAndAssignError.unassignThreadError);
          const hasCommentError = moveAndAssignError && moveAndAssignError.commentError;
          const labelSuffix = hasAssignmentError && hasCommentError ? 'inboxChangeAssignmentAndCommentError' : hasAssignmentError ? 'inboxChangeRemovalAssignmentError' : hasCommentError ? 'inboxChangeRemovalCommentError' : null;
          if (labelSuffix) {
            return /*#__PURE__*/_jsx(MoveAndAssignErrorOverlayMessage, {
              message: /*#__PURE__*/_jsx(FormattedMessage, {
                message: getDynamicNamespace({
                  prefix: 'conversations-inbox-ui.thread-list-member-overlay',
                  translationOptions: inboxChangeRemovalErrors
                }, labelSuffix),
                options: options
              })
            });
          }
          message = inbox ? 'conversations-inbox-ui.thread-list-member-overlay.inboxChangeRemovalWithInboxName' : 'conversations-inbox-ui.thread-list-member-overlay.inboxChangeRemoval';
          break;
        }
      case THREAD_STATUS_REMOVAL:
        {
          const status = getStatus(overlay);
          if (focusedThreadListMemberHasTickets) {
            const threadOrTicketClosedMessage = isAssociatedTicketOpen ? 'conversations-inbox-ui.thread-list-member-overlay.statusChangeRemoval.ended' : 'conversations-inbox-ui.thread-list-member-overlay.statusChangeRemovalForTickets.ended';
            message = status === ChatFilterOptions.STARTED ? 'conversations-inbox-ui.thread-list-member-overlay.statusChangeRemovalForTickets.started' : status === ChatFilterOptions.SOFT_DELETED ? 'conversations-inbox-ui.thread-list-member-overlay.statusChangeRemovalForTickets.deleted' : threadOrTicketClosedMessage;
          } else {
            if (status === ChatFilterOptions.STARTED) message = 'conversations-inbox-ui.thread-list-member-overlay.statusChangeRemoval.started';else if (status === ChatFilterOptions.SOFT_DELETED) {
              gatherPerformanceMetrics(MOVE_TO_TRASH_MARKER);
              message = 'conversations-inbox-ui.thread-list-member-overlay.statusChangeRemoval.deleted';
            } else {
              gatherPerformanceMetrics(MARK_THREAD_AS_CLOSED_MARKER);
              message = 'conversations-inbox-ui.thread-list-member-overlay.statusChangeRemoval.ended';
            }
          }
          break;
        }
      case ASSIGNMENT_REMOVAL:
        {
          return /*#__PURE__*/_jsx(AssignmentRemovalOverlayMessage, {
            overlay: overlay
          });
        }
      case UNKNOWN_REMOVAL:
      default:
        message = 'conversations-inbox-ui.thread-list-member-overlay.unknownRemoval';
    }
    return /*#__PURE__*/_jsx(FormattedReactMessage
    // eslint-disable-next-line
    , {
      message: message,
      options: options,
      "data-test-id": `thread-overlay-${overlayType}`
    });
  }
  render() {
    const {
      focusedThreadListMemberHasTickets,
      /* @ts-expect-error ts-migrate(2339) FIXME: Property 'isAssociatedTicketOpen' does not exist o... Remove this comment to see the full error message */ /* eslint-disable-next-line react/prop-types */
      isAssociatedTicketOpen,
      overlay,
      moveAndAssignError
    } = this.props;
    return /*#__PURE__*/_jsx(Hoverlay, {
      hovered: true,
      use: "full-card",
      foregroundContent: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        justifyContent: "center",
        "data-test-id": "thread-overlay-wrapper",
        children: /*#__PURE__*/_jsx(Text, {
          use: "on-dark",
          textAlign: "center",
          margin: "0",
          padding: "300",
          children: this.renderOverlayMessage({
            focusedThreadListMemberHasTickets,
            isAssociatedTicketOpen,
            overlay,
            moveAndAssignError
          })
        })
      }),
      children: /*#__PURE__*/_jsx(View, {
        flexShrink: 0,
        blockSize: "106px",
        inlineSize: "100%"
      })
    });
  }
}
ThreadListMemberOverlay.displayName = 'ThreadListMemberOverlay';
export default ThreadListMemberOverlay;